import React from 'react';
import { styled } from '@material-ui/core/styles';
import ParticipantStrip from '../ParticipantStrip/ParticipantStrip';

const Container = styled('div')({
  position: 'relative',
  height: '100%',
});

export default function Room() {
  return (
    <Container>
      <ParticipantStrip />
    </Container>
  );
}
